import { useMaybeSyncRecommendedRiskScores } from '@common/react/atomic';
import {
    FinancialEntitiesCtx,
    useFinancialEntities,
} from '@common/react/financialEntities';

// N.B. Keep this in sync with mobile/components/FinancialEntitiesProvider.tsx
// This should probably become a reusable component across platforms.
export const FinancialEntitiesProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const fes = useFinancialEntities();

    // In any view where components might show goals, make sure we've synced
    // recommendedRiskScoresByHorizon so the goal onboarding views work as expected.
    useMaybeSyncRecommendedRiskScores();

    return (
        <FinancialEntitiesCtx.Provider
            value={{
                fes,
            }}
        >
            {children}
        </FinancialEntitiesCtx.Provider>
    );
};
